import { useTranslation } from 'react-i18next';
import { useBrandingStore } from '../../stores/brandingStore.js';
import { useCompanyToday } from '../../hooks/useFormatDate.js';

/**
 * "© 2026 Al Wathba Building Contracting Co. LLC" — the registered company,
 * not the app's name (owner, 2026-10-26: "better to use company real name in
 * copyright not app name"). The legal name from Settings → Company; a tenant
 * that has not filled it in falls back to the trading name the app carries.
 * The year is the company's, not the browser's (docs/time-and-dates.md).
 */
export function CopyrightLine({ className }: { className?: string }): JSX.Element {
  const { t } = useTranslation();
  const branding = useBrandingStore((s) => s.branding);
  const year = useCompanyToday().slice(0, 4);
  const holder = branding?.legalName?.trim() || branding?.appName || '';
  return <span className={className}>{t('common.copyright', '© {{year}} {{holder}}', { year, holder })}</span>;
}
